// import React from "react";
// import { Doughnut } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";

// ChartJS.register(ArcElement, Tooltip);

// export default function SegmentedDoughnut({ score }) {
//   const totalSegments = 20;
//   const filledSegments = Math.round((score / 100) * totalSegments);

//   // Match your existing color logic
//   const getColor = (value) => {
//     if (value <= 50) return "#C71313";
//     if (value <= 75) return "#FBBC05";
//     if (value <= 90) return "#008200";
//     return "#0F62FE";
//   };

//   const colors = Array.from({ length: totalSegments }, (_, i) =>
//     i < filledSegments ? getColor(score) : "#E0E0E0"
//   );

//   return (
//     <Doughnut
//       data={{
//         labels: Array(totalSegments).fill(""),
//         datasets: [
//           {
//             data: Array(totalSegments).fill(5),
//             backgroundColor: colors,
//             borderWidth: 0.1,
//             borderColor: "#FFFFFF",
//             hoverBorderWidth: 2,
//           },
//         ],
//       }}
//       options={{
//         cutout: "75%",
//         plugins: {
//           tooltip: { enabled: false },
//           legend: { display: false },
//         },
//       }}
//     />
//   );
// }
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";

ChartJS.register(ArcElement, Tooltip);

// --- Your existing score → color logic ---
function getColor(value) {
  if (value <= 50) return "#C71313";
  if (value <= 75) return "#FBBC05";
  if (value <= 90) return "#008200";
  return "#0F62FE";
}

// --- Lighten any hex color ---
function lightenColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  const r = Math.min(255, (num >> 16) + 255 * percent);
  const g = Math.min(255, ((num >> 8) & 0x00ff) + 255 * percent);
  const b = Math.min(255, (num & 0x0000ff) + 255 * percent);
  return `rgb(${r}, ${g}, ${b})`;
}

export default function SegmentedDoughnut({ score }) {
  const totalSegments = 20;
  const filledSegments = Math.round((score / 100) * totalSegments);

  const activeColor = getColor(score);
  const borderShade = lightenColor(activeColor, 0.45);

  const colors = Array.from({ length: totalSegments }, (_, i) =>
    i < filledSegments ? activeColor : "#E0E0E0",
  );

  return (
    <Doughnut
      data={{
        labels: Array(totalSegments).fill(""),
        datasets: [
          {
            data: Array(totalSegments).fill(5),
            backgroundColor: colors,
            borderColor: colors.map((c) =>
              c === "#E0E0E0" ? lightenColor("#E0E0E0", 0.25) : borderShade,
            ),
            borderWidth: 2,
          },
        ],
      }}
      options={{
        cutout: "68%",
        plugins: {
          tooltip: { enabled: false },
          legend: { display: false },
        },
      }}
    />
  );
}
